<template>
  <div>
    <beast-header/>
    <div class="container">
      <div class="row">
        <div class="col-6">
          <h1>403 You are not allowed!</h1>
          <p>You are not allowed to perform that action.</p>
        </div>
      </div>
    </div>
    <beast-footer/>
  </div>
</template>

<script>
import BeastHeader from "../components/header/BeastHeader.vue";
import BeastFooter from "../components/footer/BeastFooter.vue";

export default {
  components: { BeastFooter, BeastHeader },
  mounted() {
    this.setTitle("Page not found!");
  }
};
</script>
